// import { ViewSupport49Component } from "../../../components/SupportSystem/ViewReports/ViewSupport49Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { OperationReport410Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport410Component";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ViewSupport410Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-10)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport410Component />
            <Footer />
        </div>
    );
}
